export interface VrmFrameUpdatable {
  humanoid?: { update?: () => void }
  springBoneManager?: { update: (delta: number) => void }
}

export function updateVrmFrame(
  vrm: VrmFrameUpdatable | undefined,
  delta: number,
  springBoneEnabled: boolean,
): void {
  vrm?.humanoid?.update?.()

  if (springBoneEnabled) {
    vrm?.springBoneManager?.update(delta)
  }
}
